export default "__VITE_ASSET__CTnA8BB___"